{
  "selectAsField": "Select \"{value}\" as {fieldName}",
  "typeToSearchField": "Type to search for a {fieldName}",
  "licenseFieldLabel": "Select License Plate (e.g. 215BG2)",
  "licenseFieldName": "License Plate",
  "licensePlaceholder": "Search by license plate",
  "dotFieldLabel": "Select DOT Number",
  "dotFieldName": "DOT Number",
  "dotPlaceholder": "Search by DOT number",
  "chooseOneOption": "Choose one of the options below"
}
